export enum CloseEvent {
  CANCEL = 'cancel',
  ADD_POSITION = 'add position',
  SAVE = 'save',
}
